import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpContext } from '@angular/common/http';

import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class HttpService {
  private _tokenTs: number;
  private _token: Observable<string>;

  constructor(private http: HttpClient) { }

  getHtml(url: string): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml');
    return this.http.get(url, { headers: httpHeaders, responseType: 'text' });
  }

  get<TResponse>(url: string, context?: HttpContext): Observable<TResponse> {
    if (context) {
      return this.http.get(url, { context: context })
        .pipe(map(response => response as TResponse));
    }
    return this.http.get(url)
      .pipe(map(response => response as TResponse));
  }

  prefetch(): Observable<string> {
    return this.getSustainableToken()
  }

  post<TResponse>(url: string, body: any, context?: HttpContext): Observable<TResponse> {
    return this.getSustainableToken()
      .pipe(mergeMap(token => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json;charset=UTF-8',
          '__RequestVerificationToken': token
        });
        if (context) {
          return this.http.post<TResponse>(url, JSON.stringify(body), { headers: headers, context: context });
        }
        return this.http.post<TResponse>(url, JSON.stringify(body), { headers: headers });
      }));
  }

  private getSustainableToken(): Observable<string> {
    if (this._token && (Date.now() - this._tokenTs < 750000)) {
        return this._token;
    }
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' });
    return this.http.post<string>(environment.getTokenUrl, {}, { headers: headers }).pipe(map(response => {
      this._tokenTs = Date.now();
      this._token = of(response);

      return response;
    }))
  }

  private getToken(): Observable<string> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' });
    return this.http.post<string>(environment.getTokenUrl, {}, { headers: headers })
      .pipe(map(response => response));
  }

  postReturnBlob<Blob>(url: string, body: any): Observable<Blob> {
    return this.getToken()
      .pipe(mergeMap(token => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json;charset=UTF-8',
          '__RequestVerificationToken': token
        });
        return this.http.post<Blob>(url, JSON.stringify(body), { headers: headers, responseType: 'blob' as 'json' });
      }));
  }
}
